/**
 * 2019/1/10.
 * 作者:lzq
 *功能: 角色管理模块
 */
export default {
  $getway: 'sysapi',
  getDepartList: 'depart/list',
  saveDepart: 'depart/save',
  getAllDepartList: 'depart/list',
  getListAllChildDepAjax: 'depart/listAllChildDepAjax',
  getDepartDetail: 'depart/detail',
  updateDepartStatus: 'depart/open'
};
